import { TextareaInputTemplate, TextareaInputTemplateProps } from "./template";

export type TextareaInputProps = TextareaInputTemplateProps;

export const TextareaInput: React.FC<TextareaInputProps> = (props) => {
  return <TextareaInputTemplate {...props} />;
};
